import React from "react";
import HomeBlogHead from "./HomeBlogHead";
import HomeBlogMain from "./HomeBlogMain";

const HomeBlog = () => {
  return (
    <div className="homeBlog">
      <HomeBlogHead />
      <HomeBlogMain />
    </div>
  );
};

export default HomeBlog;
